import React, { useState } from 'react';
import Auth from '../../Helpers/auth';
import Purchase from './Purchase.component';
import CourseDetails from './CourseDetails.component';
import PropTypes from 'prop-types';

// Holds userId and the amounts for the course to pass to other components
const CheckoutInnerPage = ({ courses }) => {
  const { data } = Auth.getProfile();
  const userId = data.id || localStorage.getItem('temp_id');

  const taxRate = [
    { province: 'AB', rate: 0.05 },
    { province: 'BC', rate: 0.12 },
    { province: 'MB', rate: 0.12 },
    { province: 'NB', rate: 0.15 },
    { province: 'NL', rate: 0.15 },
    { province: 'NS', rate: 0.14 },
    { province: 'NT', rate: 0.05 },
    { province: 'NU', rate: 0.05 },
    { province: 'ON', rate: 0.13 },
    { province: 'PE', rate: 0.15 },
    { province: 'QC', rate: 0.14975 },
    { province: 'SK', rate: 0.11 },
    { province: 'YT', rate: 0.05 },
  ];
  const [taxAmount, setTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedTax, setSelectedTax] = useState('');
  return (
    <>
      <CourseDetails
        courses={courses}
        taxAmount={taxAmount}
        totalAmount={totalAmount}
        selectedTax={selectedTax}
        setTaxAmount={setTaxAmount}
        setTotalAmount={setTotalAmount}
        setSelectedTax={setSelectedTax}
        taxRate={taxRate}
        userId={userId}
      />

      <Purchase userId={userId} courses={courses} />
    </>
  );
};
CheckoutInnerPage.propTypes = {
  courses: PropTypes.array,
};

export default CheckoutInnerPage;
